<header id="header" class="transparent">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-4 col-xs-4 text-left no-padding">
                <div data-toggle="modal" data-target="#menuModal" class="custom-btn">
                    <i class="icon-wb stroke R3"></i>menu
                </div>
            </div>
            <div class="col-md-4 col-xs-4 text-center logo-container">
                <a href="/#/home" title="WellBrain">
                    <img src="/assets/images/WellBrain.png" alt="WellBrain logo" class="invert">
                </a>
            </div>
        </div>
    </div>
</header>
<main id="content">
    <section id="settings">
        <div class="container">
            <div class="row">
                <div class="col-md-3 fill-left settings-sidenav">
                    <h1 class="heading heading-md desktop-show">Settings</h1>
                    <nav class="nav settings-nav desktop-show">
                        <ul class="list">
                            <li class="list-item" [ngClass]="{'active': profilePage}">
                                <a [routerLink]="['profile']" title="Profile" [ngClass]="{'state-active': profilePage}" (click)="navigate('profile')">Profile</a>
                            </li>
                            <li class="list-item" [ngClass]="{'active': !profilePage}">
                                <a [routerLink]="['password']" title="Password reset" [ngClass]="{'state-active': !profilePage}" (click)="navigate('password')">Password reset</a>
                            </li>
                        </ul>
                    </nav>
                    <nav class="nav settings-nav mobile-show">
                        <ul class="list">
                            <li class="list-item settingLiAlign">
                                <a title="Settings">Settings</a>
                            </li>
                            <li class="list-item" (click)="showSideDropdown()" class="passwordAlign">
                                <a title="Profile" class="passwordResetStyle" *ngIf="profilePage"><span class="faBakground"><i class="fa fa-caret-down"></i></span><span class="profileSetAlign">Profile</span></a>
                                <a title="Password reset" class="passwordResetStyle" *ngIf="!profilePage"><span class="faBakground"><i class="fa fa-caret-down"></i></span><span class="profileSetAlign">Password Reset</span></a>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div class="sideDropdown" *ngIf="showDropdown">
                    <ul style="list-style-type: none !important;">
                        <li class="marginBottom15 paddingLeft10" [routerLink]="['profile']" [ngClass]="{'state-active': profilePage}" (click)="navigate('profile')" (click)="showSideDropdown()"><span class="faBakgroundWhite"><i class="fa fa-caret-up"></i></span><span class="profSetAlign">PROFILE SETTINGS</span></li>
                        <li class="liAlign" [routerLink]="['password']" [ngClass]="{'state-active': !profilePage}" (click)="navigate('password')" (click)="showSideDropdown()">PASSWORD RESET</li>
                        <!-- <li class="liAlign">PRIVACY SETTINGS</li> -->
                    </ul>
                </div>
                <div class="col-md-9">
                    <div class="row desktop-show">
                        <div class="settings-action-nav fill-right" *ngIf="!profilePage">
                            <div class="col-md-5 text-center">
                                <button (click)="resetForm()" class="link link-default btn-md">Discard changes</button>
                            </div>
                            <div class="col-md-col-7 text-right">
                                <button (click)="resetNewPassword()" class="btn btn-primary btn-block btn-md text-uppercase" [disabled]="!setNewPassword.valid || error">Save</button>
                            </div>
                        </div>
                        <div class="settings-action-nav fill-right" *ngIf="profilePage">
                                <div class="col-md-5 text-center">
                                    <button (click)="resetProfileForm()" class="link link-default btn-md">Discard changes</button>
                                </div>
                                <div class="col-md-col-7 text-right">
                                    <button (click)="updateUser()" class="btn btn-primary btn-block btn-md text-uppercase" [disabled]="!userUpdateError">Save</button>
                                </div>
                            </div>
                    </div>
                    <div class="row">
                        <section class="settings-content col-md-10 col-md-offset-2">
                            <section id="settings-profile" class="row" *ngIf="profilePage">
                                <form name="settings-profile-avatar" class="col-md-12 user-avatar">
                                    <div class="row">
                                        <div class="col-md-2">
                                            <div class="avatar avatar-md">
                                                <img src="{{currentUserImage}}" alt="" title="">
                                            </div>
                                        </div>
                                        <div class="col-md-9 push-1">
                                            <input type="file" accept="image/*" name="image" #imageFileUpload class="hidden" (change)="onFileChange($event)">
                                            <a (click)="imageUpload()" class="link link-default">{{userImageName}}</a>
                                            <p class="text text-md">Recommended size : 350 x 350px</p>
                                            <p class="text text-md">Maximum file size : 1.5MB</p>
                                        </div>
                                    </div>
                                </form>
                                <form class="col-md-12">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="input-label">First Name</label>
                                                <input type="text" name="first_name" (ngModelChange)="onInputChange($event)" value="{{currentUserObj.first_name}}" [(ngModel)]="first_name" class="input">
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="input-label">Last Name</label>
                                                <input type="text" name="last_name" (ngModelChange)="onInputChange($event)" value="{{currentUserObj.last_name}}" [(ngModel)]="last_name" class="input">
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="input-label">Email</label>
                                                <input type="email" name="email" (ngModelChange)="onInputChange($event)" value="{{currentUserObj.email}}" [(ngModel)]="email" class="input">
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="input-label">Mobile Number</label>
                                                <input type="phone" name="phone_number" (ngModelChange)="onInputChange($event)" value="{{currentUserObj.phone_number}}" [(ngModel)]="phone_number" class="input">
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="input-label">Country</label>
                                                <select type="text" name="country" (ngModelChange)="onInputChange($event)" [(ngModel)]="country" class="input">
                                                    <option value="{{country.key}}" *ngFor="let country of getAllCountries | keys" [selected]="country.key == currentUserObj.country"> {{country.value}}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="input-label">State</label>
                                                <input type="text" name="state" (ngModelChange)="onInputChange($event)" value="{{currentUserObj.state}}" [(ngModel)]="state" class="input">
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label class="input-label">Address</label>
                                                <input type="text" name="address" (ngModelChange)="onInputChange($event)" value="{{currentUserObj.address}}" [(ngModel)]="address" class="input">
                                            </div>
                                        </div>
                                        <div class="col-md-6 text-center mobile-show" *ngIf="profilePage">
                                            <button (click)="updateUser()" class="btn btn-primary btn-block btn-md text-uppercase" [disabled]="!userUpdateError">Save</button>
                                        </div>
                                        <div class="col-md-6 text-center mobile-show marginTop15" *ngIf="profilePage">
                                            <button (click)="resetProfileForm()" class="link link-default btn-md">Discard changes</button>
                                        </div>
                                    </div>
                                </form>
                            </section>
                            <section id="settings-password" class="row" *ngIf="!profilePage">
                                <form novalidate [formGroup]="setNewPassword" autocomplete="off" class="col-md-12">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="input-label">Current password</label>
                                                <input type="password" name="current_password" autocomplete="off" class="input" formControlName="current_password" [(ngModel)]="model.current_password">
                                                <a (click)="forgotPassword()" class="link link-default">Did you forgot your current password?</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="input-label">New Password</label>
                                                <input type="password" name="new_password" autocomplete="off" class="input"  minlength="8" formControlName="new_password" [(ngModel)]="model.new_password" (input)="passwordValidation($event.target.value)">
                                            </div>
                                            <div class="password-validator">
                                                <div class="row">
                                                    <div class="col-md-7">
                                                        <h4>password strength</h4>
                                                        <span class="capital" [ngClass]="{'check':capital}">Capital letter</span>
                                                        <span class="digit" [ngClass]="{'check':digit}">Digit</span>
                                                        <span class="length" [ngClass]="{'check':length}">Length of 8 symbols</span>
                                                    </div>
                                                    <div class="col-md-5 text-right">
                                                        <span [attr.data-status]="passwordStatus" class="status">{{passwordStatus}}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 marginTop20">
                                            <div class="form-group">
                                                <label class="input-label">Repeat New Password</label>
                                                <input type="password" name="new_password_repeat" autocomplete="off"  minlength="8" class="input" (input)="passwordValidationCnfrm($event.target.value)" formControlName="new_password_repeat"
                                                    [(ngModel)]="model.new_password_repeat">
                                            </div>
                                        </div>
                                        <div class="col-md-6 text-center mobile-show" *ngIf="!profilePage">
                                            <button (click)="resetNewPassword()" class="btn btn-primary btn-block btn-md text-uppercase" [disabled]="!setNewPassword.valid || error" >Save</button>
                                        </div>
                                        <div class="col-md-6 text-center mobile-show" *ngIf="!profilePage">
                                                <button (click)="resetForm()" class="link link-default btn-md" >Discard changes</button>
                                        </div>
                                    </div>
                                </form>
                            </section>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </section>
</main>
<app-dailyquotes></app-dailyquotes>
<app-footer></app-footer>
<app-menu></app-menu>
<div id="change-password-success" class="modal">
    <div class="vertical-alignment-helper">
        <div class="modal-dialog vertical-align-center">
            <div class="modal-content" *ngIf="!profilePage">
                <div class="icon">
                    <img src="assets/images/checked_icon.png">
                </div>
                <h1 class="heading-lg">Password has been successfully changed !</h1>
            </div>
            <div class="modal-content" *ngIf="profilePage">
                <div class="icon">
                    <img src="assets/images/checked_icon.png">
                </div>
                <h1 class="heading-lg">Profile has been successfully updated !</h1>
            </div>
        </div>
    </div>
</div>
<div id="recover-password-success" class="modal">
    <div class="vertical-alignment-helper">
        <div class="modal-dialog vertical-align-center">
            <div class="modal-content">
                <div class="icon">
                    <img src="assets/images/checked_icon.png">
                </div>
                <h1 class="heading-lg">Your password has been recovered.</h1>
                <br>
                <p>We`ve just sent a temporary password to&nbsp;
                    <span>{{currentUserObj.email}}</span>
                </p>
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// /Volumes/Projects/WellBrain_Azure_Web/src/app/components/profile/profile.component.html